import client from './client'
import ANONYMITY_LOGIN from '@/constants/anonymity-login'
import config from '@/config'
const BASE = process.env.VUE_APP_ENV === 'preview' ? 'api/spero-auth-service-staging' : 'api/spero-auth-service'

export default {
  async anonymityLogin () {
    const url = `${BASE}/public/v1/anonymity/login`
    const {DEVICE_ID, DEVICE_NAME, DISTINCT_ID} = ANONYMITY_LOGIN
    const res = await client.post(url, { deviceId: DEVICE_ID, deviceName: DEVICE_NAME, distinctId: DISTINCT_ID }, {
      headers: {platform: config.platform}
    })
    return res && res.data
  }
}
